import React, { useState, useEffect } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GenericListPair from 'modules/common/components/GenericListPair';
import useDebounce from 'modules/common/hooks/useDebounce';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import * as actions from '../action';
import * as c from '../constant';
import CorporationContent from './CorporationContent';

const INIT_FILTER = {
  q: '',
  transaction_status: '',
  start_date: '',
  end_date: '',
  sort_by: 'desc',
  module_type: 'CDL',
  transaction_type: 'CORPORATION',
};

const cedulaStatusOption = [
  { label: 'ALL STATUS', value: '' },
  { label: 'FOR EVALUATION', value: 'FOR CHECKING' },
  { label: 'FOR PAYMENT', value: 'PENDING' },
  { label: 'FOR PAYMENT CONFIRMATION', value: 'FOR PAYMENT CONFIRMATION' },
  { label: 'FOR PRINTING', value: 'FOR PRINTING' },
  { label: 'FOR PICK-UP', value: 'FOR PICK-UP' },
  { label: 'ISSUED', value: 'ISSUED' },
  { label: 'REVOKED', value: 'REVOKED' },
  { label: 'FOR RESUBMISSION', value: 'FOR RESUBMISSION' },
  { label: 'EXPIRED REFERENCE NUMBER', value: 'EXPIRED REFERENCE NUMBER' },
  { label: 'CANCELLED', value: 'CANCELLED' },
];

function CorporationContainer({
  getTransactionList,
  transactionList,
  transactionListPager,
  match,
  isLoading,
  history,
  approveTransaction,
  showTransaction,
  startAssessment,
  tagAsPrintedTransaction,
}) {
  const [filter, setFilter] = useState(INIT_FILTER);
  const debouncedFilter = useDebounce(filter, 500);

  useEffect(() => {
    getTransactionList(debouncedFilter);
  }, [JSON.stringify(debouncedFilter)]);

  const handleOnChange = (key, value) => {
    setFilter((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleApprove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to tag as received this application?',
      (remarks) => {
        startAssessment(_.get(data, 'id'), () => {
          approveTransaction(
            _.get(data, 'id'),
            {
              remarks,
            },
            () => {
              showTransaction(_.get(data, 'id'));
            }
          );
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleTagAsPrinted = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure you want to tag this application for pick-up?',
      (remarks) => {
        startAssessment(_.get(data, 'id'), () => {
          tagAsPrintedTransaction(
            _.get(data, 'id'),
            {
              remarks,
            },
            () => {
              showTransaction(_.get(data, 'id'));
            }
          );
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleReject = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to Reject this application',
      (remarks) => {
        startAssessment(_.get(data, 'id'), () => {
          approveTransaction(
            _.get(data, 'id'),
            {
              remarks,
              status: 'PENDING LAB TEST',
            },
            () => {
              showTransaction(_.get(data, 'id'));
            }
          );
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:id?`}
        render={({ match: { params } }) => (
          <GenericListPair
            statusOptions={cedulaStatusOption}
            moduleName="Corporation Transactions"
            // getData={getTransactionList}
            // setParams={param}
            setKeyword={(e) =>
              handleOnChange(
                e?.target.name,
                e?.target.value
                // e?.target.value.length
              )
            }
            setStatusFilter={(props) =>
              handleOnChange('transaction_status', props?.value)
            }
            status={_.get(filter, 'transaction_status') || ''}
            keyword={_.get(filter, 'q') || ''}
            keywordPlaceholder="Search Transaction..."
            listName="Transaction"
            label="Transaction List"
            renderItem={(item) => (
              <div className="px-3 py-3">
                <div className="transaction-list-company">
                  {`${_.get(
                    item,
                    'included.module.attributes.president_authorized_representative'
                  )}`}
                </div>
                <h4 className="mt-1 mb-0 transaction-list-name">
                  {' '}
                  {_.get(
                    item,
                    'included.module.attributes.name_of_corporation_partnership'
                  )}{' '}
                </h4>
              </div>
            )}
            isLoading={isLoading}
            statusFilter
            selected={params.id}
            data={transactionList}
            dataPager={transactionListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:id?`}
                    render={() => (
                      <CorporationContent
                        onApprove={handleApprove}
                        onTagAsPrinted={handleTagAsPrinted}
                        onReject={handleReject}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:id?`}
                  render={() =>
                    !params.business_Id && transactionList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(transactionList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
            handleSort={(props) => handleOnChange('sort_by', props?.value)}
            handleChangePage={(page) =>
              setFilter((prev) => ({ ...prev, page }))
            }
          />
        )}
      />
    </div>
  );
}

CorporationContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getTransactionList: PropTypes.instanceOf(Function).isRequired,
  transactionList: PropTypes.instanceOf(Array).isRequired,
  transactionListPager: PropTypes.instanceOf(Object).isRequired,
  approveTransaction: PropTypes.instanceOf(Function).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  startAssessment: PropTypes.instanceOf(Function).isRequired,
  tagAsPrintedTransaction: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  transactionList: _.get(api, `${c.GET_TRANSACTION}.list`) || [],
  transactionListPager: _.get(api, `${c.GET_TRANSACTION}.pager`) || {},
  isLoading: api.loading.indexOf(c.GET_TRANSACTION) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(CorporationContainer);
